export default "__VITE_ASSET__DPI8stv___"